import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Document Watermark Preset API
 */
class DocumentWatermarkApi extends ApiBase {
  /**
   * Check if preset name already exists
   * @param {*} profileName
   */
  async checkNameExists(profileName) {
    const request = {
      url: `${this.API_URL}/documentwatermarks?name=${profileName}`,
      headers: this.getHeaders(),
      method: 'GET',
      validateStatus: function(status) {
        return (status >= 200 && status < 300) || status === 404;
      }
    };

    const response = await axios.request(request);

    return response.data.totalCount > 0;
  }
}

export default new DocumentWatermarkApi();
